var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/car"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5712 2.47656H7.42875C5.25 2.47656 4.76875 3.56156 4.48875 4.89156L3.5 9.62531H17.5L16.5113 4.89156C16.2313 3.56156 15.75 2.47656 13.5712 2.47656Z",
    fill: "white",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2402 17.3425C19.3364 18.3663 18.5139 19.25 17.4639 19.25H15.8189C14.8739 19.25 14.7427 18.8475 14.5764 18.3487L14.4014 17.8238C14.1564 17.1063 13.9989 16.625 12.7389 16.625H8.25891C6.99891 16.625 6.81516 17.1675 6.59641 17.8238L6.42141 18.3487C6.25516 18.8475 6.12391 19.25 5.17891 19.25H3.53391C2.48391 19.25 1.66141 18.3663 1.75766 17.3425L2.24766 12.0137C2.37016 10.7012 2.62391 9.625 4.91641 9.625H16.0814C18.3739 9.625 18.6277 10.7012 18.7502 12.0137L19.2402 17.3425Z",
    fill: "white",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5 7H2.625",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.375 7H17.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.5 2.625V4.375",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.1875 4.375H11.8125",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.25 13.125H7.875",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.125 13.125H15.75",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.f083c496561d22320ef070c89f11f13b.svg";
export { ForwardRef as ReactComponent };